import { colors } from '@insurancemenu/imenu-components-lib';
import { ComponentStylesProps, HeaderCommonPropsType } from '@insurancemenu/imenu-components-lib/dist/types';
import { createUseStyles } from 'react-jss';

const styles: ComponentStylesProps<HeaderCommonPropsType> = {
  spinnerWrapper: {
    width: '100vw',
    height: '100vh',
  },
  appWrapper: {
    backgroundColor: colors.neutral[100],
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    '@media(max-width: 840px)': {
      paddingTop: '5rem',
    },
  },
  widePageWrapper: {
    position: 'relative',
    maxWidth: '90%',
    margin: '0 auto',
    paddingBottom: '6rem',
    minHeight: '90vh',
  },
  pageWrapper: {
    position: 'relative',
    minHeight: '100vh',
    maxWidth: '109.6rem',
    width: '90%',
    margin: '0 auto',
    paddingBottom: '6rem',
  },
  // form pages
  narrowPageWrapper: {
    position: 'relative',
    minHeight: '100vh',
    maxWidth: '90rem',
    width: '90%',
    margin: '0 auto',
    paddingBottom: '6rem',
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
